export class PostObject {
  msg: string;
  resultCode: string;
  detail: string;
}
